import { render } from "./Chat.vue?vue&type=template&id=70884f82&scoped=true&ts=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=70884f82&lang=scss&scoped=true"

import exportComponent from "D:\\work\\h5\\2024sclh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70884f82"]])

export default __exports__